<template>
  <div>
    <el-form label-width="140px">
      <el-form-item :label="`选择漫游类型：`">
        <el-radio v-model="sonRoamingData.radio" label="1">普通漫游</el-radio>
        <el-radio v-model="sonRoamingData.radio" label="2">绕点飞行</el-radio>
        <el-radio v-model="sonRoamingData.radio" label="3">视点飞行</el-radio>
      </el-form-item>
      <el-form-item
        v-if="sonRoamingData.radio == '1' || sonRoamingData.radio == '3'"
        style="width: 95%;"
        :label="`选择漫游：`"
      >
        <el-select v-model="sonRoamingData.ordinaryId" placeholder="请选择">
          <el-option
            v-for="item in options.ordinary"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option
        ></el-select>
      </el-form-item>
      <el-form-item label="延迟执行：">
        <el-switch v-model="sonRoamingData.delay"></el-switch>
      </el-form-item>
      <el-form-item
        v-if="sonRoamingData.delay"
        style="width: 360px"
        label="延迟时间："
      >
        <el-input
          placeholder="请输入时间"
          v-model.number="sonRoamingData.delayTime"
        >
          <template slot="append">秒</template>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { selectRoaming, BimViewPntsGroupingDetail } from "@/api/api";
export default {
  name: "screenplay-roaming",
  components: {},
  props: ["roamingData"],
  model: {
    prop: "roamingData",
  },
  data() {
    return {
      sonRoamingData: this.roamingData,
      options: {
        ordinary: [],
      },
    };
  },
  watch: {
    "sonRoamingData.radio"(v) {
      this.sonRoamingData.ordinaryId = null;
      if (v == 3) {
        this.get_viewpoint();
      } else if (v == 1) {
        this.getSelectRoaming({
          projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
        });
      }
    },
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },

  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    init() {
      let searchData = {
        projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
      };
      if (this.sonRoamingData.radio == 3) {
        this.get_viewpoint();
      } else {
        this.getSelectRoaming(searchData);
      }
    },
    get_viewpoint() {
      BimViewPntsGroupingDetail({
        projectId: window.sessionStorage.getItem("nowProjectId"),
      })
        .then((res) => {
          if (res.data.code == 200) {
            res.data.data.forEach((el) => {
              el.name = el.title;
            });
            this.options.ordinary = res.data.data;
          }
        })
        .catch((err) => {});
    },
    getSelectRoaming(searchData) {
      selectRoaming(searchData).then((res) => {
        let { code, data } = res.data;
        this.options.ordinary = data.rows;
      });
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {},
};
</script>
